import React from 'react'
interface ExpandLeftPaneIconProp {
    className?: string
}
const ExpandLeftPaneIcon = ({ className = '' }: ExpandLeftPaneIconProp) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="16"
        viewBox="0 0 18 16"
        fill="#185E8E"
        className={className}
    >
        <path
            d="M12.1179 8.28572L18 14.2L16.2 16L8.48571 8.28572L16.2 0.57143L18 2.37143L12.1179 8.28572ZM3.63214 8.28572L9.51429 14.2L7.71429 16L0 8.28572L7.71429 0.57143L9.51429 2.37143L3.63214 8.28572Z"
            fill="#185E8E"
        />
    </svg>
)
export default ExpandLeftPaneIcon
